"use strict";

import { onReady } from '../core/ready';

const toggleSelector = '[data-bs-toggle="dropdown"], .dropdown-toggle';
let listenersBound = false;
let activeDropdown = null;

const getToggleFromDropdown = (dropdown) => dropdown ? dropdown.querySelector(toggleSelector) : null;

const getMenuFromDropdown = (dropdown) => dropdown ? dropdown.querySelector('.dropdown-menu') : null;

const closeDropdown = (dropdown) => {
    if (!dropdown) return;

    dropdown.classList.remove('show');

    const menu = getMenuFromDropdown(dropdown);
    if (menu) {
        menu.classList.remove('show');
    }

    const toggle = getToggleFromDropdown(dropdown);
    if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
    }

    if (activeDropdown === dropdown) {
        activeDropdown = null;
    }
};

const openDropdown = (dropdown, toggle) => {
    if (!dropdown) return;

    if (activeDropdown && activeDropdown !== dropdown) {
        closeDropdown(activeDropdown);
    }

    dropdown.classList.add('show');

    const menu = getMenuFromDropdown(dropdown);
    if (menu) {
        menu.classList.add('show');
    }

    if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
    }

    activeDropdown = dropdown;
};

const toggleDropdown = (dropdown, toggle) => {
    if (!dropdown) return;
    const isOpen = dropdown.classList.contains('show');
    if (isOpen) {
        closeDropdown(dropdown);
    } else {
        openDropdown(dropdown, toggle);
    }
};

const handleClick = (event) => {
    const toggle = event.target instanceof Element ? event.target.closest(toggleSelector) : null;
    if (toggle) {
        const dropdown = toggle.closest('.dropdown');
        if (!dropdown) return;
        event.preventDefault();
        event.stopPropagation();
        toggleDropdown(dropdown, toggle);
        return;
    }

    if (!activeDropdown) return;

    const autoClose = (activeDropdown.dataset.bsAutoClose || 'true').toLowerCase();
    if (autoClose === 'false') return;
    if (autoClose === 'outside' && activeDropdown.contains(event.target)) return;
    closeDropdown(activeDropdown);
};

const handleKeydown = (event) => {
    if (event.key !== 'Escape') return;
    if (!activeDropdown) return;
    closeDropdown(activeDropdown);
};

const bindDropdowns = () => {
    if (listenersBound) return;
    document.addEventListener('click', handleClick);
    document.addEventListener('keydown', handleKeydown);
    listenersBound = true;
};

onReady(bindDropdowns);
